// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__211tq","title":"InfoRow_title__txdI6"};